export const RequestStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
  Expired: 4,
  Cancelled: 5
};
